import React, { useState,useRef } from "react";
import { toast } from "react-toastify";
import { api, superAdminReqConfig } from "../../include/api";
import SuperAdminHeader from "./Header";

const SuperNotificationForm = () => {
    const [formData, setFormData] = useState({
        title: "",
        body: "",
        imageFile: null,
        previewUrl: null,
        clickUrl: "", // Added url field
    });
        
    const fileInputRef = useRef(null); 

    const [errors, setErrors] = useState({
        title: "",
        body: "",
    });
    const [saving, setSaving] = useState(false);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        // console.log("Form Data:", formData);

        // Clear error messages when the user starts typing
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: value ? "" : prevErrors[name],
        }));
    };

    // Handle file input change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prevData) => ({
                ...prevData,
                imageFile: file,
                previewUrl: URL.createObjectURL(file),
            }));
        }
    };

    // Clear form fields after successful save
    const clearFields = () => {
        setFormData({
            title: "",
            body: "",
            imageFile: null,
            previewUrl: null,
            clickUrl: "",
        });
        setErrors({
            title: "",
            body: "",
        });
            if (fileInputRef.current) {
            fileInputRef.current.value = ""; // <-- clear file input
        }
    };


    // Handle form submission
    const handleSave = () => {
        let valid = true;

        // Validate title and body
        if (!formData.title.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                title: "Title is required",
            }));
            valid = false;
        }

        if (!formData.body.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                body: "Body text is required",
            }));
            valid = false;
        }
        if (!formData.clickUrl.trim()) {
        setErrors((prevErrors) => ({
            ...prevErrors,
            clickUrl: "URL is required",
        }));
        valid = false;
    }

        

        if (valid) {
            setSaving(true);

            // console.log("Form Data before sending:", formData.clickUrl);

            const dataToSend = new FormData();
            dataToSend.append("title", formData.title);
            dataToSend.append("body", formData.body);
            dataToSend.append("clickUrl", formData.clickUrl); // Include url in the payload
            if (formData.imageFile) {
                dataToSend.append("imageFile", formData.imageFile);
            }

            for (let pair of dataToSend.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
            }


            api
                .post("/notification/", dataToSend, superAdminReqConfig())
                .then((response) => {
                    if (response.status === 200) {
                        toast.success("Notification sent successfully!");

                        // Save notification to localStorage
                        const newNotification = {
                            title: formData.title,
                            body: formData.body,
                            image: formData.previewUrl,
                            clickUrl: formData.clickUrl,
                            dateTime: new Date().toLocaleString(),
                        };
                        const existingNotifications =
                            JSON.parse(localStorage.getItem("notifications")) || [];
                        localStorage.setItem(
                            "notifications",
                            JSON.stringify([...existingNotifications, newNotification])
                        );

                        clearFields();
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message || "Something went wrong");
                    } else {
                        toast.error(error.message || "Network error");
                    }
                })
                .finally(() => setSaving(false));
        }
    };

    return (
        <SuperAdminHeader>
            <div className="fixed-top-bar">
                <div className="container">
                    <h2 className="mb-4 fs-1">Push Notification</h2>

                    <form className="mb-5">
                        {/* Title Input */}
                        <div className="mb-3">
                            <label htmlFor="title" className="form-label">
                                Title
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="title"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="Enter title"
                            />
                            {errors.title && (
                                <div className="text-danger small">{errors.title}</div>
                            )}
                        </div>

                        {/* Body Input */}
                        <div className="mb-3">
                            <label htmlFor="body" className="form-label">
                                Body
                            </label>
                            <textarea
                                className="form-control"
                                id="body"
                                name="body"
                                value={formData.body}
                                onChange={handleChange}
                                placeholder="Enter body text"
                                rows="3"
                            />
                            {errors.body && (
                                <div className="text-danger small">{errors.body}</div>
                            )}
                        </div>

                        {/* Image File Input */}
                        <div className="mb-3">
                            <label htmlFor="imageFile" className="form-label">
                                Upload Image
                            </label>
                            <input
                                type="file"
                                id="imageFile"
                                name="imageFile"
                                className="form-control"
                                accept="image/*"
                                onChange={handleFileChange}
                                ref={fileInputRef} // <-- add this
                            />
                            {formData.previewUrl && (
                                <div className="mt-3">
                                    <p>Image Preview:</p>
                                    <img
                                        src={formData.previewUrl}
                                        alt="Preview"
                                        style={{ width: "100%", maxWidth: "300px", height: "300px" }}
                                    />
                                </div>
                            )}
                        </div>
                             {/* URL Input */}
                            <div className="mb-3">
                                <label htmlFor="url" className="form-label">
                                    URL
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="clickUrl"
                                    name="clickUrl"
                                    value={formData.clickUrl}
                                    onChange={handleChange}
                                    placeholder="Enter URL"
                                />
                                {errors.clickUrl && (
                                    <div className="text-danger small">{errors.clickUrl}</div>
                                )}
                            </div>


                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {saving ? "Sending..." : "Send"}
                        </button>
                    </form>
                </div>
            </div>
        </SuperAdminHeader>
    );
};

export default SuperNotificationForm;
